import { parseMessage } from '@features/ui-form/services/customErrorMap';
import { useTranslation } from 'next-i18next';

interface ErrorMessageProps {
  /**
   * An i18n key, a key carrying its values (`messageWithValues`), or a ready
   * string. `''` renders nothing.
   */
  error: string;
  children?: (message: string) => React.ReactNode;
}

/**
 * The translated error line of a field, rendered by `FieldWrapper`.
 * Reads no form context: the message is a prop.
 */
const ErrorMessage = ({ error, children }: ErrorMessageProps) => {
  const { t } = useTranslation();

  if (!error) {
    return null;
  }

  const { key, values } = parseMessage(error);
  const translated = t(key, values);
  return <span>{children ? children(translated) : translated}</span>;
};

export default ErrorMessage;
